import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface SidePanelUniDriver extends BaseUniDriver {
  /** Click close the button */
  clickClose(): Promise<void>;
  /** Click help the button */
  clickHelp(): Promise<void>;
  /** Get title text */
  getTitleText(): Promise<string>;
  /** Get subtitle text */
  getSubtitleText(): Promise<string>;
  /** Get tooltip text */
  getTooltipContent(): Promise<string>;
  /** Check if divider exists */
  isHeaderDividerExists(): Promise<boolean>;
  /** Check if close button exists */
  isCloseButtonExists(): Promise<boolean>;
  /** Check if help button exists */
  isHelpButtonExists(): Promise<boolean>;
  /** Check if divider exists */
  isFooterDividerExists(): Promise<boolean>;
}
